<template>
  <section>
    <application-list-modal
      :id="`application-list-${uuid}`"
      ref="application-list-modal"
      @submit="showApplicationListConfirmSubmitMessage"
    ></application-list-modal>
    <applicant-information-modal
      :id="`applicant-information-${uuid}`"
      ref="applicant-information-modal"
      @cancel="showApplicationList"
      @submit="showApplicationSummary"
    ></applicant-information-modal>
    <application-summary-modal
      :id="`application-summary-modal-${uuid}`"
      ref="application-summary-modal"
      :form_data="form_data"
      @submit="showApplicationCompleteMessage"
    ></application-summary-modal>
    <application-success-message-modal
      :id="`application-success-message-${uuid}`"
      ref="application-success-message"
      @submit="showApplicationList"
    ></application-success-message-modal>
    <application-list-confirm-submit-message-modal
      :id="`application-list-confirm-submit-message-${uuid}`"
      ref="application-list-confirm-submit-message"
      @confirm="showApplicantInformation"
    ></application-list-confirm-submit-message-modal>
    <application-complete-message-modal
      :id="`application-complete-message-${uuid}`"
      :contact_email_address="contact_email_address"
      :contact_extension_number="contact_extension_number"
      ref="application-complete-message-modal"
    ></application-complete-message-modal>
    <application-notice-message-modal
      :id="`application-notice-message-modal-${uuid}`"
      :section="noticeSection"
      ref="application-notice-message-modal"
    ></application-notice-message-modal>
  </section>
</template>
<script>
import Vue from 'vue'
// import VueCompositionAPI from '@vue/composition-api'

import UUID from '@estudioliver/vue-uuid-v4'

import { FormPlugin } from 'bootstrap-vue'
import { FormGroupPlugin } from 'bootstrap-vue'
import { FormSelectPlugin } from 'bootstrap-vue'
import { ModalPlugin } from 'bootstrap-vue'
import { Validators, createFormValidation } from '@lemoncode/fonk'

import i18n from '@/plugins/i18n.js'
import ConstantApiService from '@/services/budaedu-api-services/constant-api-service.js'
import DeliveryAreaApiService from '@/services/budaedu-api-services/delivery-area-api-service.js'
import ApplicationListConfirmSubmitMessageModal from './modals/ApplicationListConfirmSubmitMessageModal.vue'
import ApplicationListModal from './modals/ApplicationListModal.vue'
import ApplicantInformationModal from './modals/ApplicantInformationModal.vue'
import ApplicationCompleteMessageModal from './modals/ApplicationCompleteMessageModal.vue'
import ApplicationSuccessMessageModal from './modals/ApplicationSuccessMessageModal.vue'
import ApplicationSummaryModal from './modals/ApplicationSummaryModal.vue'
import ApplicationNoticeMessageModal from './modals/ApplicationNoticeMessageModal.vue'

Vue.use(FormPlugin)
Vue.use(FormGroupPlugin)
Vue.use(FormSelectPlugin)
Vue.use(ModalPlugin)
Vue.use(UUID)

Vue.use(ConstantApiService)
Vue.use(DeliveryAreaApiService)


export default {
  i18n,
  name: 'dharma-application-form',
  data() {
    return {
      uuid: null,
      form_data: null,
      contact_email_address: '',
      contact_extension_number: '',
      contact_email_addresses: [],
      contact_extension_numbers: [],
      noticeSection: 1, // 控制顯示哪一段提示
      // form_submit_disabled: false,
      // validation_result: {}
    }
  },
  methods: {
    hideApplicationList() {
      this.$bvModal.hide(`application-list-${this.uuid}`)
    },
    showApplicationList() {
      this.$bvModal.show(`application-list-${this.uuid}`)
    },
    showApplicationListConfirmSubmitMessage() {
      this.showApplicationList()
      this.$bvModal.show(`application-list-confirm-submit-message-${this.uuid}`)
    },
    showApplicantInformation() {
      this.hideApplicationList()
      this.$bvModal.show(`applicant-information-${this.uuid}`)

      if (this.$i18n.locale === 'en') {
        // 顯示第一次提示
        this.noticeSection = 1
        this.$bvModal.show(`application-notice-message-modal-${this.uuid}`)
      }
    },
    showApplicationSummary(data) {
      this.form_data = data
      this.$nextTick(() => {
        this.$bvModal.show(`application-summary-modal-${this.uuid}`)
      })
    },
    async showApplicationCompleteMessage(data) {
      const result = await this.$deliveryAreaApiService.getByEnglishName(data.delivery.area, 'include=responsibler')
      if (result.data && result.data.responsibler) {
        const responsibler = result.data.responsibler
        this.contact_email_address = responsibler.email
        if (data.delivery.area === 'Taiwan') {
          this.contact_extension_number = responsibler.extension
        } else {
          this.contact_extension_number = ''
        }
      } else {
        this.contact_email_address = this.contact_email_addresses[data.delivery.area]
          ? this.contact_email_addresses[data.delivery.area]
          : this.contact_email_addresses['Other']
        if (data.delivery.area === 'Taiwan') {
          this.contact_extension_number = this.contact_extension_numbers[data.delivery.area]
            ? this.contact_extension_numbers[data.delivery.area]
            : this.contact_extension_numbers['Other']
        }
      }

      this.$nextTick(() => {
        this.$bvModal.show(`application-complete-message-${this.uuid}`)
      })
      
      if (this.$i18n.locale === 'en') {
        // 顯示第二次提示
        this.noticeSection = 2
        this.$bvModal.show(`application-notice-message-modal-${this.uuid}`)
      }
    },
    async setContactEmailAddresses() { 
      const item = await this.$constantApiService.getFromMemberSystem()
      this.contact_email_addresses = item.data.contact_email_addresses
    },
    async setContactExtensionNumbers() {
      const item = await this.$constantApiService.getFromMemberSystem()
      this.contact_extension_numbers = item.data.contact_extension_numbers
    }
  },
  async created() {
    // alert(`Vue version : ${Vue.version}`)
    this.uuid = this.$uuidKey()
    await this.setContactEmailAddresses()
    await this.setContactExtensionNumbers()
  },
  components: {
    ApplicationListConfirmSubmitMessageModal,
    ApplicationListModal,
    ApplicationCompleteMessageModal,
    ApplicationNoticeMessageModal,
    ApplicationSuccessMessageModal,
    ApplicationSummaryModal,
    ApplicantInformationModal
  }
}
</script>